// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 10 6%27%3e %3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m1 1 4 4 4-4%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M1 5.917 5.724 10.5 15 1.5%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M0.5 6h14%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./images/feedbackbg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./images/feedbackpink.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./images/icons/presentation.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./images/icons/star.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./images/icons/whiteemail.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./images/icons/whitesmallphone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./images/icons/whitetg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./images/icons/arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./images/icons/whitepresentation.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.6 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

[data-tooltip-style^='light'] + .tooltip > .tooltip-arrow:before {
  border-style: solid;
  border-color: #e5e7eb;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='top'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='right'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='bottom'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='left'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

.tooltip[data-popper-placement^='top'] > .tooltip-arrow {
  bottom: -4px;
}

.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow {
  top: -4px;
}

.tooltip[data-popper-placement^='left'] > .tooltip-arrow {
  right: -4px;
}

.tooltip[data-popper-placement^='right'] > .tooltip-arrow {
  left: -4px;
}

.tooltip.invisible > .tooltip-arrow:before {
  visibility: hidden;
}

[data-popper-arrow],[data-popper-arrow]:before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

[data-popper-arrow] {
  visibility: hidden;
}

[data-popper-arrow]:before {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
}

[data-popper-arrow]:after {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
  position: absolute;
  width: 9px;
  height: 9px;
  background: inherit;
}

[role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #4b5563;
}

[role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #4b5563;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow] {
  bottom: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow] {
  top: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow] {
  right: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow] {
  left: -5px;
}

[role="tooltip"].invisible > [data-popper-arrow]:before {
  visibility: hidden;
}

[role="tooltip"].invisible > [data-popper-arrow]:after {
  visibility: hidden;
}

[type='text'],[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
}

select:not([size]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 0.75em 0.75em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

:is([dir=rtl]) select:not([size]) {
  background-position: left 0.75rem center;
  padding-right: 0.75rem;
  padding-left: 0;
}

[multiple] {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: unset;
          print-color-adjust: unset;
}

[type='checkbox'],[type='radio'] {
  appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked,.dark [type='checkbox']:checked,.dark [type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 0.55em 0.55em;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

.dark [type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-color: currentColor;
  border-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px auto inherit;
}

input[type=file]::file-selector-button {
  color: white;
  background: #1f2937;
  border: 0;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 2rem;
  padding-right: 1rem;
  margin-inline-start: -1rem;
  margin-inline-end: 1rem;
}

input[type=file]::file-selector-button:hover {
  background: #374151;
}

:is([dir=rtl]) input[type=file]::file-selector-button {
  padding-right: 2rem;
  padding-left: 1rem;
}

.dark input[type=file]::file-selector-button {
  color: white;
  background: #4b5563;
}

.dark input[type=file]::file-selector-button:hover {
  background: #6b7280;
}

input[type="range"]::-webkit-slider-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #2563eb;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-webkit-slider-thumb {
  background: #9ca3af;
}

.dark input[type="range"]:disabled::-webkit-slider-thumb {
  background: #6b7280;
}

input[type="range"]:focus::-webkit-slider-thumb {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1px;
  --tw-ring-color: rgb(164 202 254 / var(--tw-ring-opacity));
}

input[type="range"]::-moz-range-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #2563eb;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-moz-range-thumb {
  background: #9ca3af;
}

.dark input[type="range"]:disabled::-moz-range-thumb {
  background: #6b7280;
}

input[type="range"]::-moz-range-progress {
  background: #3b82f6;
}

input[type="range"]::-ms-fill-lower {
  background: #3b82f6;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-44 {
  bottom: -11rem;
}
.-left-1 {
  left: -0.25rem;
}
.-left-1\\.5 {
  left: -0.375rem;
}
.-left-3 {
  left: -0.75rem;
}
.-left-\\[300px\\] {
  left: -300px;
}
.-right-1 {
  right: -0.25rem;
}
.-right-3 {
  right: -0.75rem;
}
.-right-44 {
  right: -11rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-3 {
  top: -0.75rem;
}
.-top-4 {
  top: -1rem;
}
.-top-9 {
  top: -2.25rem;
}
.-top-\\[25px\\] {
  top: -25px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-16 {
  bottom: 4rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-8 {
  bottom: 2rem;
}
.end-2 {
  inset-inline-end: 0.5rem;
}
.end-2\\.5 {
  inset-inline-end: 0.625rem;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-14 {
  left: 3.5rem;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-5 {
  left: 1.25rem;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[18px\\] {
  left: 18px;
}
.right-0 {
  right: 0px;
}
.right-10 {
  right: 2.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-28 {
  right: 7rem;
}
.right-8 {
  right: 2rem;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-14 {
  top: 3.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-auto {
  z-index: auto;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-start-1 {
  grid-column-start: 1;
}
.col-start-3 {
  grid-column-start: 3;
}
.col-start-4 {
  grid-column-start: 4;
}
.col-start-6 {
  grid-column-start: 6;
}
.col-start-8 {
  grid-column-start: 8;
}
.col-end-2 {
  grid-column-end: 2;
}
.col-end-4 {
  grid-column-end: 4;
}
.col-end-5 {
  grid-column-end: 5;
}
.col-end-8 {
  grid-column-end: 8;
}
.col-end-9 {
  grid-column-end: 9;
}
.row-span-1 {
  grid-row: span 1 / span 1;
}
.-m-1\\.5 {
  margin: -0.375rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[160px\\] {
  margin-bottom: 160px;
}
.me-1\\.5 {
  margin-inline-end: 0.375rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-2\\.5 {
  margin-inline-end: 0.625rem;
}
.me-4 {
  margin-inline-end: 1rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-\\[460px\\] {
  margin-left: 460px;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-1\\/2 {
  height: 50%;
}
.h-10 {
  height: 2.5rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[317px\\] {
  height: 317px;
}
.h-\\[326px\\] {
  height: 326px;
}
.h-\\[345px\\] {
  height: 345px;
}
.h-\\[380px\\] {
  height: 380px;
}
.h-\\[386px\\] {
  height: 386px;
}
.h-\\[41px\\] {
  height: 41px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[524px\\] {
  height: 524px;
}
.h-\\[calc\\(100\\%_-_32px\\)\\] {
  height: calc(100% - 32px);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[180px\\] {
  max-height: 180px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[317px\\] {
  max-height: 317px;
}
.max-h-\\[331px\\] {
  max-height: 331px;
}
.max-h-\\[380px\\] {
  max-height: 380px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[90dvh\\] {
  max-height: 90dvh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[110px\\] {
  min-height: 110px;
}
.min-h-\\[124px\\] {
  min-height: 124px;
}
.min-h-\\[140px\\] {
  min-height: 140px;
}
.min-h-\\[156px\\] {
  min-height: 156px;
}
.min-h-\\[208px\\] {
  min-height: 208px;
}
.min-h-\\[220px\\] {
  min-height: 220px;
}
.min-h-\\[317px\\] {
  min-height: 317px;
}
.min-h-\\[90px\\] {
  min-height: 90px;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/5 {
  width: 20%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\/4 {
  width: 50%;
}
.w-20 {
  width: 5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[237px\\] {
  width: 237px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[370px\\] {
  width: 370px;
}
.w-\\[717px\\] {
  width: 717px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[98\\%\\] {
  width: 98%;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.min-w-11 {
  min-width: 2.75rem;
}
.min-w-14 {
  min-width: 3.5rem;
}
.min-w-9 {
  min-width: 2.25rem;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[206px\\] {
  min-width: 206px;
}
.min-w-\\[20px\\] {
  min-width: 20px;
}
.min-w-\\[283px\\] {
  min-width: 283px;
}
.min-w-\\[300px\\] {
  min-width: 300px;
}
.min-w-\\[343px\\] {
  min-width: 343px;
}
.min-w-\\[50px\\] {
  min-width: 50px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[100vw\\] {
  max-width: 100vw;
}
.max-w-\\[1776px\\] {
  max-width: 1776px;
}
.max-w-\\[239px\\] {
  max-width: 239px;
}
.max-w-\\[253px\\] {
  max-width: 253px;
}
.max-w-\\[260px\\] {
  max-width: 260px;
}
.max-w-\\[263px\\] {
  max-width: 263px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[309px\\] {
  max-width: 309px;
}
.max-w-\\[340px\\] {
  max-width: 340px;
}
.max-w-\\[370px\\] {
  max-width: 370px;
}
.max-w-\\[375px\\] {
  max-width: 375px;
}
.max-w-\\[394px\\] {
  max-width: 394px;
}
.max-w-\\[42px\\] {
  max-width: 42px;
}
.max-w-\\[491px\\] {
  max-width: 491px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[501px\\] {
  max-width: 501px;
}
.max-w-\\[502px\\] {
  max-width: 502px;
}
.max-w-\\[60\\%\\] {
  max-width: 60%;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[800px\\] {
  max-width: 800px;
}
.max-w-\\[850px\\] {
  max-width: 850px;
}
.max-w-\\[900px\\] {
  max-width: 900px;
}
.max-w-\\[950px\\] {
  max-width: 950px;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-screen-2xl {
  max-width: 1536px;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.origin-\\[0\\] {
  transform-origin: 0;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[50px\\] {
  --tw-translate-y: -50px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full {
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-none {
  transform: none;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-wait {
  cursor: wait;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center {
  scroll-snap-align: center;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-flow-col {
  grid-auto-flow: column;
}
.grid-flow-dense {
  grid-auto-flow: dense;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-rows-\\[0fr\\] {
  grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\] {
  grid-template-rows: 1fr;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[11px\\] {
  gap: 11px;
}
.gap-\\[24px\\] {
  gap: 24px;
}
.gap-\\[50px\\] {
  gap: 50px;
}
.gap-\\[9px\\] {
  gap: 9px;
}
.-space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1rem * var(--tw-space-x-reverse));
  margin-left: calc(-1rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-px > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.justify-self-auto {
  justify-self: auto;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.\\!overflow-x-hidden {
  overflow-x: hidden !important;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.\\!scroll-auto {
  scroll-behavior: auto !important;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.\\!text-ellipsis {
  text-overflow: ellipsis !important;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[2\\.5rem\\] {
  border-radius: 2.5rem;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-e-lg {
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-s-lg {
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-\\[\\#3269A4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(50 105 164 / var(--tw-border-opacity));
}
.border-\\[\\#C53EAE\\] {
  --tw-border-opacity: 1;
  border-color: rgb(197 62 174 / var(--tw-border-opacity));
}
.border-\\[\\#D42E12\\] {
  --tw-border-opacity: 1;
  border-color: rgb(212 46 18 / var(--tw-border-opacity));
}
.border-cyan-300 {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity));
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}
.border-cyan-600 {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity));
}
.border-cyan-700 {
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity));
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(132 225 188 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}
.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity));
}
.border-green-700 {
  --tw-border-opacity: 1;
  border-color: rgb(4 108 78 / var(--tw-border-opacity));
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(180 198 252 / var(--tw-border-opacity));
}
.border-indigo-400 {
  --tw-border-opacity: 1;
  border-color: rgb(141 162 251 / var(--tw-border-opacity));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity));
}
.border-lime-300 {
  --tw-border-opacity: 1;
  border-color: rgb(190 242 100 / var(--tw-border-opacity));
}
.border-lime-400 {
  --tw-border-opacity: 1;
  border-color: rgb(163 230 53 / var(--tw-border-opacity));
}
.border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity));
}
.border-orange {
  --tw-border-opacity: 1;
  border-color: rgb(254 128 22 / var(--tw-border-opacity));
}
.border-pink {
  --tw-border-opacity: 1;
  border-color: rgb(197 62 174 / var(--tw-border-opacity));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity));
}
.border-purple-900 {
  --tw-border-opacity: 1;
  border-color: rgb(74 29 150 / var(--tw-border-opacity));
}
.border-red {
  --tw-border-opacity: 1;
  border-color: rgb(212 46 18 / var(--tw-border-opacity));
}
.border-teal-300 {
  --tw-border-opacity: 1;
  border-color: rgb(126 220 226 / var(--tw-border-opacity));
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(250 202 21 / var(--tw-border-opacity));
}
.border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(227 160 8 / var(--tw-border-opacity));
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}
.border-yellow-600 {
  --tw-border-opacity: 1;
  border-color: rgb(159 88 10 / var(--tw-border-opacity));
}
.\\!bg-\\[\\#D76200\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(215 98 0 / var(--tw-bg-opacity)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[\\#3269A4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(50 105 164 / var(--tw-bg-opacity));
}
.bg-\\[\\#A18165\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(161 129 101 / var(--tw-bg-opacity));
}
.bg-\\[\\#C53EAE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(197 62 174 / var(--tw-bg-opacity));
}
.bg-\\[\\#D42E12\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(212 46 18 / var(--tw-bg-opacity));
}
.bg-\\[\\#ECECEC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 236 236 / var(--tw-bg-opacity));
}
.bg-\\[\\#F8F8F8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity));
}
.bg-\\[\\#FE8016\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 128 22 / var(--tw-bg-opacity));
}
.bg-\\[\\#FFFFFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 27 / var(--tw-bg-opacity));
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}
.bg-cyan-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity));
}
.bg-cyan-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity));
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
.bg-cyan-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity));
}
.bg-cyan-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity));
}
.bg-gray {
  --tw-bg-opacity: 1;
  background-color: rgb(115 115 115 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(49 196 141 / var(--tw-bg-opacity));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 250 247 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 122 85 / var(--tw-bg-opacity));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 108 78 / var(--tw-bg-opacity));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 255 / var(--tw-bg-opacity));
}
.bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(141 162 251 / var(--tw-bg-opacity));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(88 80 236 / var(--tw-bg-opacity));
}
.bg-lightpink {
  --tw-bg-opacity: 1;
  background-color: rgb(255 211 204 / var(--tw-bg-opacity));
}
.bg-lime-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity));
}
.bg-lime-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(163 230 53 / var(--tw-bg-opacity));
}
.bg-lime-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity));
}
.bg-orange {
  --tw-bg-opacity: 1;
  background-color: rgb(254 128 22 / var(--tw-bg-opacity));
}
.bg-pink {
  --tw-bg-opacity: 1;
  background-color: rgb(197 62 174 / var(--tw-bg-opacity));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 235 254 / var(--tw-bg-opacity));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(246 245 255 / var(--tw-bg-opacity));
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(126 58 242 / var(--tw-bg-opacity));
}
.bg-purple-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(108 43 217 / var(--tw-bg-opacity));
}
.bg-red {
  --tw-bg-opacity: 1;
  background-color: rgb(212 46 18 / var(--tw-bg-opacity));
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(213 245 246 / var(--tw-bg-opacity));
}
.bg-teal-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 116 129 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity));
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(227 160 8 / var(--tw-bg-opacity));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 234 / var(--tw-bg-opacity));
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(159 88 10 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-\\[url\\(\\"\\.\\/images\\/feedbackbg\\.png\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.bg-\\[url\\(\\"\\.\\/images\\/feedbackpink\\.png\\"\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.bg-\\[url\\(\\"https\\:\\/\\/admin\\.aversprofi\\.ru\\/images\\/feedbackblue\\.png\\"\\)\\] {
  background-image: url("https://admin.aversprofi.ru/images/feedbackblue.png");
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-cyan-400 {
  --tw-gradient-from: #22d3ee var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500 {
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-400 {
  --tw-gradient-from: #31C48D var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 196 141 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-200 {
  --tw-gradient-from: #d9f99d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 249 157 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #9061F9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(144 97 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #7E3AF2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 58 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-200 {
  --tw-gradient-from: #AFECEF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(175 236 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400 {
  --tw-gradient-from: #16BDCA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 189 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-cyan-500 {
  --tw-gradient-to: rgb(6 182 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #06b6d4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-600 {
  --tw-gradient-to: rgb(8 145 178 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0891b2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-green-500 {
  --tw-gradient-to: rgb(14 159 110 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0E9F6E var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-lime-400 {
  --tw-gradient-to: rgb(163 230 53 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a3e635 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-600 {
  --tw-gradient-to: rgb(126 58 242 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #7E3AF2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-500 {
  --tw-gradient-to: rgb(6 148 162 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0694A2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-cyan-500 {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-cyan-600 {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-cyan-700 {
  --tw-gradient-to: #0e7490 var(--tw-gradient-to-position);
}
.to-green-600 {
  --tw-gradient-to: #057A55 var(--tw-gradient-to-position);
}
.to-lime-200 {
  --tw-gradient-to: #d9f99d var(--tw-gradient-to-position);
}
.to-lime-500 {
  --tw-gradient-to: #84cc16 var(--tw-gradient-to-position);
}
.to-purple-700 {
  --tw-gradient-to: #6C2BD9 var(--tw-gradient-to-position);
}
.to-teal-600 {
  --tw-gradient-to: #047481 var(--tw-gradient-to-position);
}
.to-yellow-200 {
  --tw-gradient-to: #FCE96A var(--tw-gradient-to-position);
}
.bg-\\[length\\:1000\\%_103\\%\\] {
  background-size: 1000% 103%;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-current {
  fill: currentColor;
}
.fill-cyan-600 {
  fill: #0891b2;
}
.fill-green-500 {
  fill: #0E9F6E;
}
.fill-purple-600 {
  fill: #7E3AF2;
}
.fill-yellow-400 {
  fill: #E3A008;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-20 {
  padding-left: 5rem;
  padding-right: 5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[34px\\] {
  padding-left: 34px;
  padding-right: 34px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-28 {
  padding-top: 7rem;
  padding-bottom: 7rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-\\[24px\\] {
  padding-bottom: 24px;
}
.pl-0 {
  padding-left: 0px;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-20 {
  padding-left: 5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.ps-5 {
  padding-inline-start: 1.25rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pt-32 {
  padding-top: 8rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-start {
  text-align: start;
}
.font-helio {
  font-family: "helio", sans-serif;
}
.font-helio_c {
  font-family: "main-font-c", sans;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[1rem\\] {
  font-size: 1rem;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[300\\] {
  font-weight: 300;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.\\!leading-\\[1em\\] {
  line-height: 1em !important;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-none {
  line-height: 1;
}
.leading-tight {
  line-height: 1.25;
}
.text-\\[\\#3269A4\\] {
  --tw-text-opacity: 1;
  color: rgb(50 105 164 / var(--tw-text-opacity));
}
.text-\\[\\#505050\\] {
  --tw-text-opacity: 1;
  color: rgb(80 80 80 / var(--tw-text-opacity));
}
.text-\\[\\#5A5A5A\\] {
  --tw-text-opacity: 1;
  color: rgb(90 90 90 / var(--tw-text-opacity));
}
.text-\\[\\#737373\\] {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}
.text-\\[\\#C53EAE\\] {
  --tw-text-opacity: 1;
  color: rgb(197 62 174 / var(--tw-text-opacity));
}
.text-\\[\\#D42E12\\] {
  --tw-text-opacity: 1;
  color: rgb(212 46 18 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(29 29 27 / var(--tw-text-opacity));
}
.text-cyan-300 {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}
.text-cyan-800 {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity));
}
.text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity));
}
.text-gray {
  --tw-text-opacity: 1;
  color: rgb(115 115 115 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(5 122 85 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(4 108 78 / var(--tw-text-opacity));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(3 84 63 / var(--tw-text-opacity));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(1 71 55 / var(--tw-text-opacity));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(104 117 245 / var(--tw-text-opacity));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(81 69 205 / var(--tw-text-opacity));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(66 56 157 / var(--tw-text-opacity));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(54 47 120 / var(--tw-text-opacity));
}
.text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / var(--tw-text-opacity));
}
.text-lime-700 {
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity));
}
.text-lime-800 {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity));
}
.text-lime-900 {
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity));
}
.text-orange {
  --tw-text-opacity: 1;
  color: rgb(254 128 22 / var(--tw-text-opacity));
}
.text-pink {
  --tw-text-opacity: 1;
  color: rgb(197 62 174 / var(--tw-text-opacity));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(144 97 249 / var(--tw-text-opacity));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(126 58 242 / var(--tw-text-opacity));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(108 43 217 / var(--tw-text-opacity));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(85 33 181 / var(--tw-text-opacity));
}
.text-red {
  --tw-text-opacity: 1;
  color: rgb(212 46 18 / var(--tw-text-opacity));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(6 148 162 / var(--tw-text-opacity));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(4 116 129 / var(--tw-text-opacity));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(3 102 114 / var(--tw-text-opacity));
}
.text-teal-800 {
  --tw-text-opacity: 1;
  color: rgb(5 80 92 / var(--tw-text-opacity));
}
.text-teal-900 {
  --tw-text-opacity: 1;
  color: rgb(1 68 81 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(227 160 8 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(194 120 3 / var(--tw-text-opacity));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(142 75 16 / var(--tw-text-opacity));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(114 59 19 / var(--tw-text-opacity));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(99 49 18 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.placeholder-cyan-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(14 116 144 / var(--tw-placeholder-opacity));
}
.placeholder-green-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(4 108 78 / var(--tw-placeholder-opacity));
}
.placeholder-yellow-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(142 75 16 / var(--tw-placeholder-opacity));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-80 {
  opacity: 0.8;
}
.mix-blend-lighten {
  mix-blend-mode: lighten;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-cyan-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity));
}
.ring-cyan-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity));
}
.ring-green-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity));
}
.ring-purple-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(144 97 249 / var(--tw-ring-opacity));
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.ring-yellow-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 202 21 / var(--tw-ring-opacity));
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c background-color\\2c border-color\\2c text-decoration-color\\2c fill\\2c stroke\\2c box-shadow\\] {
  transition-property: color,background-color,border-color,text-decoration-color,fill,stroke,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-0 {
  transition-delay: 0s;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[overflow\\:-moz-scrollbars-none\\] {
  overflow: -moz-scrollbars-none;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}


.App {
  text-align: center;
}

main {
  max-width: 1576px;
  margin-left: auto;
  margin-right: auto;
}

iframe#webpack-dev-server-client-overlay{display:none!important}

  .custom-scroll::-webkit-scrollbar {
    width: 5px;
  }
  
  /* Track */
  .custom-scroll::-webkit-scrollbar-track {
    background-color: #EDEDED; 
    border-radius: 20px;
  }
   
  /* Handle */
  .custom-scroll::-webkit-scrollbar-thumb {
    background: #FE8016; 
    border-radius: 20px;
  }
  
  /* Handle on hover */
  .custom-scroll::-webkit-scrollbar-thumb:hover {
    background: #f58930; 
  }



@media (max-width:900px) {

  /* main {
    padding: 0 12px;
  } */

  section {
    padding: 0 12px;
    margin-bottom: 56px !important;
  }

  /* .custom-bg {
    background-image: url('./images/background.png');
    background-position: center;
    background-size: 130% 100%;
    background-size: cover !important;
    padding-top: 30px;
    padding-bottom: 100px;
    background-repeat: no-repeat;
  } */

}

section {
  width: 100%;
  margin-bottom: 100px;
  padding: 0 20px;

}



.swiper-scrollbar-drag {
  cursor: pointer;
}

/* .custom-bg {
  background-image: url('./images/background.png');
  background-position: center right;
  background-size: 85% 150%;
  padding-top: 30px;
  padding-bottom: 100px;
  background-repeat: no-repeat;
} */

@media (max-width:900px) {
  .swiper {
    --swiper-pagination-bullet-size: 10px !important;
  }

}
.css-1119e81-MuiPaper-root-MuiSnackbarContent-root{
  background-color: white !important;
  border-radius:10px;
}

.red-swiper .swiper-scrollbar-drag{
  background-color: #D42E12 !important;
}

.MuiBox-root:focus-visible{
  outline:none;
  border: none;
}

.swiper-pagination{
  display:none !important;
}

.modules-swiper .swiper-wrapper {
  padding-bottom: 1% !important;
}

@media (max-width:900px) {
  .swiper {
    --swiper-pagination-bullet-size: 10px !important;

  }
  .modules-swiper {
    padding-bottom: 40px !important;
  }

  .swiper-pagination{
    display:block !important;
  }
}

[type='text']:focus {
    outline: none; 
    box-shadow: none; 
    border-color: initial;
}

.swiper-scrollbar {
  height: 10px !important;
}

.small-scroll .swiper-scrollbar{
  height: 5px !important;
}

.pink-scroll .swiper-scrollbar-drag{
  background-color: #C53EAE !important;
}

.swiper-scrollbar-drag {
  background-color: #FE8016 !important;
}

.blue-swiper .swiper-scrollbar-drag{
  background-color: #3269A4 !important;
}

.orange-swiper .swiper-scrollbar-drag{
  background-color: #FE8016 !important;
}

#mob_menu {
  position: fixed;
  right: 0;
  top: 20px;
  background: #1D1D1B;
  width: 283px;
  height: calc(100dvh - 20px);
  border-radius: 15px 0px 0px 15px;
  padding: 16px 16px 32px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 40px;
  z-index: 999;
}

#mob_menu .yellow_icon_btn {
  max-width: 42px;
  max-height: 42px;
  min-width: 42px;
  min-height: 42px;
}

#mob_menu .yellow_icon_btn img {
  max-width: 42px;
}

@media screen and (min-width: 920px) {
  #mob_menu {
    display: none;
  }
}

@media screen and (max-width: 920px) {
  .mob_element_open {
    transform: translateX(0px);
    animation: openMobElement 0.5s ease 1;
  }

  @keyframes openMobElement {
    from {
      transform: translateX(100vw);
    }

    to {
      transform: translateX(0px);
    }
  }

  .mob_element_close {
    transform: translateX(100vw);
    animation: closeMobElement 0.5s ease 1;
  }

  @keyframes closeMobElement {
    from {
      transform: translateX(0px);
    }

    to {
      transform: translateX(100vw);
    }
  }
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.placeholder\\:text-\\[\\#BABABA\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(186 186 186 / var(--tw-text-opacity));
}

.before\\:mb-2::before {
  content: var(--tw-content);
  margin-bottom: 0.5rem;
}

.before\\:mt-2::before {
  content: var(--tw-content);
  margin-top: 0.5rem;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:flex::before {
  content: var(--tw-content);
  display: flex;
}

.before\\:items-center::before {
  content: var(--tw-content);
  align-items: center;
}

.before\\:justify-center::before {
  content: var(--tw-content);
  justify-content: center;
}

.before\\:pt-1::before {
  content: var(--tw-content);
  padding-top: 0.25rem;
}

.before\\:text-sm::before {
  content: var(--tw-content);
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.before\\:content-\\[url\\(\\.\\/images\\/icons\\/presentation\\.svg\\)\\]::before {
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  content: var(--tw-content);
}

.before\\:content-\\[url\\(\\.\\/images\\/icons\\/star\\.svg\\)\\]::before {
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  content: var(--tw-content);
}

.before\\:content-\\[url\\(\\.\\/images\\/icons\\/whiteemail\\.svg\\)\\]::before {
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  content: var(--tw-content);
}

.before\\:content-\\[url\\(\\.\\/images\\/icons\\/whitesmallphone\\.svg\\)\\]::before {
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  content: var(--tw-content);
}

.before\\:content-\\[url\\(\\.\\/images\\/icons\\/whitetg\\.svg\\)\\]::before {
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  content: var(--tw-content);
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:left-1::after {
  content: var(--tw-content);
  left: 0.25rem;
}

.after\\:left-px::after {
  content: var(--tw-content);
  left: 1px;
}

.after\\:top-0\\.5::after {
  content: var(--tw-content);
  top: 0.125rem;
}

.after\\:top-px::after {
  content: var(--tw-content);
  top: 1px;
}

.after\\:ml-3::after {
  content: var(--tw-content);
  margin-left: 0.75rem;
}

.after\\:flex::after {
  content: var(--tw-content);
  display: flex;
}

.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}

.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}

.after\\:h-6::after {
  content: var(--tw-content);
  height: 1.5rem;
}

.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}

.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}

.after\\:w-6::after {
  content: var(--tw-content);
  width: 1.5rem;
}

.after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:items-center::after {
  content: var(--tw-content);
  align-items: center;
}

.after\\:justify-center::after {
  content: var(--tw-content);
  justify-content: center;
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:content-\\[url\\(\\.\\/images\\/icons\\/arrow\\.svg\\)\\]::after {
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  content: var(--tw-content);
}

.first\\:ml-0:first-child {
  margin-left: 0px;
}

.first\\:mt-0:first-child {
  margin-top: 0px;
}

.first\\:rounded-t-lg:first-child {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.first\\:border-t-0:first-child {
  border-top-width: 0px;
}

.first\\:pt-0:first-child {
  padding-top: 0px;
}

.last\\:mr-0:last-child {
  margin-right: 0px;
}

.last\\:rounded-b-lg:last-child {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.odd\\:bg-white:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.checked\\:bg-\\[\\#D76200\\]:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(215 98 0 / var(--tw-bg-opacity));
}

.hover\\:cursor-not-allowed:hover {
  cursor: not-allowed;
}

.hover\\:border-red:hover {
  --tw-border-opacity: 1;
  border-color: rgb(212 46 18 / var(--tw-border-opacity));
}

.hover\\:bg-\\[\\#F3573D\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 87 61 / var(--tw-bg-opacity));
}

.hover\\:bg-\\[\\#FFA65B\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 166 91 / var(--tw-bg-opacity));
}

.hover\\:bg-cyan-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}

.hover\\:bg-cyan-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity));
}

.hover\\:bg-cyan-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity));
}

.hover\\:bg-cyan-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity));
}

.hover\\:bg-green-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity));
}

.hover\\:bg-indigo-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity));
}

.hover\\:bg-lime-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity));
}

.hover\\:bg-orange:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 128 22 / var(--tw-bg-opacity));
}

.hover\\:bg-pink:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(197 62 174 / var(--tw-bg-opacity));
}

.hover\\:bg-purple-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity));
}

.hover\\:bg-red:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(212 46 18 / var(--tw-bg-opacity));
}

.hover\\:bg-teal-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity));
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.hover\\:bg-yellow-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity));
}

.hover\\:bg-gradient-to-br:hover {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.hover\\:text-cyan-700:hover {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}

.hover\\:text-red:hover {
  --tw-text-opacity: 1;
  color: rgb(212 46 18 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-70:hover {
  opacity: 0.7;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:before\\:content-\\[url\\(\\.\\/images\\/icons\\/whitepresentation\\.svg\\)\\]:hover::before {
  --tw-content: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  content: var(--tw-content);
}

.focus\\:z-10:focus {
  z-index: 10;
}

.focus\\:border-cyan-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}

.focus\\:border-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.focus\\:border-green-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity));
}

.focus\\:border-orange:focus {
  --tw-border-opacity: 1;
  border-color: rgb(254 128 22 / var(--tw-border-opacity));
}

.focus\\:border-yellow-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}

.focus\\:text-cyan-700:focus {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-cyan-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(103 232 249 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 145 178 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity));
}

.focus\\:ring-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(188 240 218 / var(--tw-ring-opacity));
}

.focus\\:ring-green-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(132 225 188 / var(--tw-ring-opacity));
}

.focus\\:ring-green-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 196 141 / var(--tw-ring-opacity));
}

.focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity));
}

.focus\\:ring-green-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 122 85 / var(--tw-ring-opacity));
}

.focus\\:ring-green-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 84 63 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(180 198 252 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(141 162 251 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(81 69 205 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 249 157 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(190 242 100 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(163 230 53 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(77 124 15 / var(--tw-ring-opacity));
}

.focus\\:ring-orange:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 128 22 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 215 254 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(202 191 253 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(172 148 250 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity));
}

.focus\\:ring-teal-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 220 226 / var(--tw-ring-opacity));
}

.focus\\:ring-teal-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 189 202 / var(--tw-ring-opacity));
}

.focus\\:ring-teal-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 116 129 / var(--tw-ring-opacity));
}

.focus\\:ring-yellow-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 202 21 / var(--tw-ring-opacity));
}

.focus\\:ring-yellow-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(227 160 8 / var(--tw-ring-opacity));
}

.focus\\:ring-yellow-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity));
}

.active\\:focus\\:bg-\\[\\#FE8016\\]:focus:active {
  --tw-bg-opacity: 1;
  background-color: rgb(254 128 22 / var(--tw-bg-opacity));
}

.active\\:focus\\:bg-transparent:focus:active {
  background-color: transparent;
}

.active\\:focus\\:shadow-\\[inset_0_3px_4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\]:focus:active {
  --tw-shadow: inset 0 3px 4px rgba(0,0,0,0.15);
  --tw-shadow-colored: inset 0 3px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.enabled\\:hover\\:bg-cyan-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-cyan-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-green-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-green-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(3 84 63 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-indigo-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 255 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-lime-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-purple-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(85 33 181 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-teal-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(213 245 246 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-yellow-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-yellow-500:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(194 120 3 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-gradient-to-bl:hover:enabled {
  background-image: linear-gradient(to bottom left, var(--tw-gradient-stops));
}

.enabled\\:hover\\:bg-gradient-to-br:hover:enabled {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.enabled\\:hover\\:bg-gradient-to-l:hover:enabled {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}

.enabled\\:hover\\:from-teal-200:hover:enabled {
  --tw-gradient-from: #AFECEF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(175 236 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.enabled\\:hover\\:to-lime-200:hover:enabled {
  --tw-gradient-to: #d9f99d var(--tw-gradient-to-position);
}

.enabled\\:hover\\:text-cyan-700:hover:enabled {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group:first-child .group-first\\:hidden {
  display: none;
}

.group\\/body:first-child .group\\/row:first-child .group-first\\/body\\:group-first\\/row\\:first\\:rounded-tl-lg:first-child {
  border-top-left-radius: 0.5rem;
}

.group\\/head:first-child .group-first\\/head\\:first\\:rounded-tl-lg:first-child {
  border-top-left-radius: 0.5rem;
}

.group\\/body:first-child .group\\/row:first-child .group-first\\/body\\:group-first\\/row\\:last\\:rounded-tr-lg:last-child {
  border-top-right-radius: 0.5rem;
}

.group\\/head:first-child .group-first\\/head\\:last\\:rounded-tr-lg:last-child {
  border-top-right-radius: 0.5rem;
}

.group\\/body:last-child .group\\/row:last-child .group-last\\/body\\:group-last\\/row\\:first\\:rounded-bl-lg:first-child {
  border-bottom-left-radius: 0.5rem;
}

.group\\/body:last-child .group\\/row:last-child .group-last\\/body\\:group-last\\/row\\:last\\:rounded-br-lg:last-child {
  border-bottom-right-radius: 0.5rem;
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:bg-cyan-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-lime-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-teal-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}

.group:hover .group-hover\\:bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:text-\\[\\#E8E8E8\\] {
  --tw-text-opacity: 1;
  color: rgb(232 232 232 / var(--tw-text-opacity));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.group:focus .group-focus\\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.group:focus .group-focus\\:ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.group:focus .group-focus\\:ring-cyan-500\\/25 {
  --tw-ring-color: rgb(6 182 212 / 0.25);
}

.group:focus .group-focus\\:ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}

.group:enabled:hover .group-enabled\\:group-hover\\:bg-opacity-0 {
  --tw-bg-opacity: 0;
}

.group:enabled:hover .group-enabled\\:group-hover\\:text-inherit {
  color: inherit;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-1\\/2 {
  top: 50%;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:left-0 {
  left: 0px;
}

.peer:focus ~ .peer-focus\\:top-2 {
  top: 0.5rem;
}

.peer:focus ~ .peer-focus\\:-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.dark\\:block:is(.dark *) {
  display: block;
}

.dark\\:hidden:is(.dark *) {
  display: none;
}

.dark\\:border-none:is(.dark *) {
  border-style: none;
}

.dark\\:border-cyan-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity));
}

.dark\\:border-cyan-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}

.dark\\:border-cyan-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity));
}

.dark\\:border-green-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(49 196 141 / var(--tw-border-opacity));
}

.dark\\:border-green-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.dark\\:border-green-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity));
}

.dark\\:border-indigo-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(88 80 236 / var(--tw-border-opacity));
}

.dark\\:border-lime-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(101 163 13 / var(--tw-border-opacity));
}

.dark\\:border-teal-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(4 116 129 / var(--tw-border-opacity));
}

.dark\\:border-white:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.dark\\:border-yellow-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(227 160 8 / var(--tw-border-opacity));
}

.dark\\:border-yellow-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(159 88 10 / var(--tw-border-opacity));
}

.dark\\:bg-black:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 27 / var(--tw-bg-opacity));
}

.dark\\:bg-cyan-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}

.dark\\:bg-cyan-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity));
}

.dark\\:bg-cyan-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity));
}

.dark\\:bg-cyan-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / var(--tw-bg-opacity));
}

.dark\\:bg-green-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity));
}

.dark\\:bg-green-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity));
}

.dark\\:bg-green-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity));
}

.dark\\:bg-green-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(5 122 85 / var(--tw-bg-opacity));
}

.dark\\:bg-green-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(1 71 55 / var(--tw-bg-opacity));
}

.dark\\:bg-indigo-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity));
}

.dark\\:bg-indigo-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(104 117 245 / var(--tw-bg-opacity));
}

.dark\\:bg-indigo-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(88 80 236 / var(--tw-bg-opacity));
}

.dark\\:bg-lime-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity));
}

.dark\\:bg-lime-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity));
}

.dark\\:bg-purple-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity));
}

.dark\\:bg-purple-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(144 97 249 / var(--tw-bg-opacity));
}

.dark\\:bg-purple-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 58 242 / var(--tw-bg-opacity));
}

.dark\\:bg-purple-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(74 29 150 / var(--tw-bg-opacity));
}

.dark\\:bg-teal-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity));
}

.dark\\:bg-teal-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(4 116 129 / var(--tw-bg-opacity));
}

.dark\\:bg-transparent:is(.dark *) {
  background-color: transparent;
}

.dark\\:bg-yellow-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity));
}

.dark\\:bg-yellow-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity));
}

.dark\\:bg-yellow-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(159 88 10 / var(--tw-bg-opacity));
}

.dark\\:bg-yellow-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(99 49 18 / var(--tw-bg-opacity));
}

.dark\\:bg-opacity-80:is(.dark *) {
  --tw-bg-opacity: 0.8;
}

.dark\\:text-cyan-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity));
}

.dark\\:text-cyan-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity));
}

.dark\\:text-cyan-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity));
}

.dark\\:text-cyan-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity));
}

.dark\\:text-cyan-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity));
}

.dark\\:text-cyan-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity));
}

.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(49 196 141 / var(--tw-text-opacity));
}

.dark\\:text-green-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity));
}

.dark\\:text-green-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(5 122 85 / var(--tw-text-opacity));
}

.dark\\:text-green-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(3 84 63 / var(--tw-text-opacity));
}

.dark\\:text-green-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(1 71 55 / var(--tw-text-opacity));
}

.dark\\:text-indigo-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(88 80 236 / var(--tw-text-opacity));
}

.dark\\:text-indigo-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(66 56 157 / var(--tw-text-opacity));
}

.dark\\:text-indigo-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(54 47 120 / var(--tw-text-opacity));
}

.dark\\:text-lime-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity));
}

.dark\\:text-lime-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity));
}

.dark\\:text-lime-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity));
}

.dark\\:text-purple-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(126 58 242 / var(--tw-text-opacity));
}

.dark\\:text-purple-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(85 33 181 / var(--tw-text-opacity));
}

.dark\\:text-purple-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 29 150 / var(--tw-text-opacity));
}

.dark\\:text-teal-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(4 116 129 / var(--tw-text-opacity));
}

.dark\\:text-teal-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(5 80 92 / var(--tw-text-opacity));
}

.dark\\:text-teal-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(1 68 81 / var(--tw-text-opacity));
}

.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark\\:text-yellow-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(159 88 10 / var(--tw-text-opacity));
}

.dark\\:text-yellow-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(114 59 19 / var(--tw-text-opacity));
}

.dark\\:text-yellow-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(99 49 18 / var(--tw-text-opacity));
}

.dark\\:mix-blend-color:is(.dark *) {
  mix-blend-mode: color;
}

.dark\\:shadow-sm-light:is(.dark *) {
  --tw-shadow: 0 2px 5px 0px rgba(255, 255, 255, 0.08);
  --tw-shadow-colored: 0 2px 5px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:ring-cyan-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity));
}

.dark\\:ring-green-500:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity));
}

.dark\\:ring-purple-600:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity));
}

.dark\\:ring-yellow-500:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity));
}

.dark\\:ring-offset-cyan-600:is(.dark *) {
  --tw-ring-offset-color: #0891b2;
}

.dark\\:ring-offset-green-600:is(.dark *) {
  --tw-ring-offset-color: #057A55;
}

.dark\\:ring-offset-green-800:is(.dark *) {
  --tw-ring-offset-color: #03543F;
}

.dark\\:ring-offset-indigo-700:is(.dark *) {
  --tw-ring-offset-color: #5145CD;
}

.dark\\:ring-offset-lime-700:is(.dark *) {
  --tw-ring-offset-color: #4d7c0f;
}

.dark\\:ring-offset-purple-600:is(.dark *) {
  --tw-ring-offset-color: #7E3AF2;
}

.dark\\:ring-offset-teal-600:is(.dark *) {
  --tw-ring-offset-color: #047481;
}

.dark\\:ring-offset-yellow-400:is(.dark *) {
  --tw-ring-offset-color: #E3A008;
}

.dark\\:hover\\:bg-cyan-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-cyan-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-green-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(132 225 188 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-indigo-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(180 198 252 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-lime-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-purple-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(202 191 253 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-teal-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 220 226 / var(--tw-bg-opacity));
}

.dark\\:hover\\:bg-yellow-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 202 21 / var(--tw-bg-opacity));
}

.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark\\:focus\\:border-cyan-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}

.dark\\:focus\\:border-green-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.dark\\:focus\\:border-yellow-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}

.dark\\:focus\\:bg-cyan-600:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity));
}

.dark\\:focus\\:text-white:focus:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark\\:focus\\:ring-cyan-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-cyan-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 145 178 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-cyan-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-cyan-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-green-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-green-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 122 85 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-green-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 108 78 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-green-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 84 63 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-indigo-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(81 69 205 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-lime-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(77 124 15 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-lime-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 98 18 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-purple-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-purple-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(85 33 181 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-purple-900:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 29 150 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-teal-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 116 129 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-teal-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 102 114 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-teal-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 80 92 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-yellow-400:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(227 160 8 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-yellow-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-yellow-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(142 75 16 / var(--tw-ring-opacity));
}

.dark\\:focus\\:ring-yellow-900:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 49 18 / var(--tw-ring-opacity));
}

.dark\\:enabled\\:hover\\:border-cyan-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity));
}

.dark\\:enabled\\:hover\\:border-green-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(4 108 78 / var(--tw-border-opacity));
}

.dark\\:enabled\\:hover\\:border-indigo-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(81 69 205 / var(--tw-border-opacity));
}

.dark\\:enabled\\:hover\\:border-lime-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(77 124 15 / var(--tw-border-opacity));
}

.dark\\:enabled\\:hover\\:border-teal-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(3 102 114 / var(--tw-border-opacity));
}

.dark\\:enabled\\:hover\\:border-yellow-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(142 75 16 / var(--tw-border-opacity));
}

.dark\\:enabled\\:hover\\:bg-cyan-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity));
}

.dark\\:enabled\\:hover\\:bg-green-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(4 108 78 / var(--tw-bg-opacity));
}

.dark\\:enabled\\:hover\\:bg-indigo-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(81 69 205 / var(--tw-bg-opacity));
}

.dark\\:enabled\\:hover\\:bg-lime-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / var(--tw-bg-opacity));
}

.dark\\:enabled\\:hover\\:bg-purple-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(108 43 217 / var(--tw-bg-opacity));
}

.dark\\:enabled\\:hover\\:bg-teal-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 102 114 / var(--tw-bg-opacity));
}

.dark\\:enabled\\:hover\\:bg-yellow-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(142 75 16 / var(--tw-bg-opacity));
}

.dark\\:enabled\\:hover\\:text-white:hover:enabled:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.enabled\\:dark\\:hover\\:text-white:hover:is(.dark *):enabled {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.group:hover .dark\\:group-hover\\:bg-cyan-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity));
}

.group:hover .dark\\:group-hover\\:bg-green-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(132 225 188 / var(--tw-bg-opacity));
}

.group:hover .dark\\:group-hover\\:bg-indigo-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(180 198 252 / var(--tw-bg-opacity));
}

.group:hover .dark\\:group-hover\\:bg-lime-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity));
}

.group:hover .dark\\:group-hover\\:bg-purple-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(202 191 253 / var(--tw-bg-opacity));
}

.group:hover .dark\\:group-hover\\:bg-teal-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 220 226 / var(--tw-bg-opacity));
}

.group:hover .dark\\:group-hover\\:bg-yellow-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 202 21 / var(--tw-bg-opacity));
}

.group:hover .dark\\:group-hover\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

@media (max-width: 1600px) {

  .max-\\[1600px\\]\\:hidden {
    display: none;
  }
}

@media (max-width: 1575px) {

  .max-\\[1575px\\]\\:w-full {
    width: 100%;
  }

  .max-\\[1575px\\]\\:max-w-none {
    max-width: none;
  }
}

@media (max-width: 1400px) {

  .max-\\[1400px\\]\\:flex {
    display: flex;
  }

  .max-\\[1400px\\]\\:flex-col {
    flex-direction: column;
  }

  .max-\\[1400px\\]\\:flex-wrap {
    flex-wrap: wrap;
  }

  .max-\\[1400px\\]\\:gap-8 {
    gap: 2rem;
  }
}

@media (max-width: 1320px) {

  .max-\\[1320px\\]\\:h-\\[775px\\] {
    height: 775px;
  }

  .max-\\[1320px\\]\\:min-h-\\[360px\\] {
    min-height: 360px;
  }

  .max-\\[1320px\\]\\:pt-5 {
    padding-top: 1.25rem;
  }
}

@media (max-width: 1300px) {

  .max-\\[1300px\\]\\:flex {
    display: flex;
  }

  .max-\\[1300px\\]\\:hidden {
    display: none;
  }
}

@media (max-width: 1270px) {

  .max-\\[1270px\\]\\:hidden {
    display: none;
  }

  .max-\\[1270px\\]\\:w-\\[40px\\] {
    width: 40px;
  }

  .max-\\[1270px\\]\\:rotate-90 {
    --tw-rotate: 90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .max-\\[1270px\\]\\:flex-wrap {
    flex-wrap: wrap;
  }
}

@media (max-width: 1025px) {

  .max-\\[1025px\\]\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .max-\\[1025px\\]\\:hidden {
    display: none;
  }

  .max-\\[1025px\\]\\:max-w-\\[150px\\] {
    max-width: 150px;
  }

  .max-\\[1025px\\]\\:gap-3 {
    gap: 0.75rem;
  }

  .max-\\[1025px\\]\\:gap-4 {
    gap: 1rem;
  }

  .max-\\[1025px\\]\\:p-4 {
    padding: 1rem;
  }
}

@media (max-width: 1023px) {

  .max-\\[1023px\\]\\:hidden {
    display: none;
  }

  .max-\\[1023px\\]\\:\\!flex-col {
    flex-direction: column !important;
  }

  .max-\\[1023px\\]\\:\\!items-start {
    align-items: flex-start !important;
  }
}

@media (max-width: 1000px) {

  .max-\\[1000px\\]\\:-right-0 {
    right: -0px;
  }

  .max-\\[1000px\\]\\:ml-1 {
    margin-left: 0.25rem;
  }

  .max-\\[1000px\\]\\:hidden {
    display: none;
  }

  .max-\\[1000px\\]\\:h-5 {
    height: 1.25rem;
  }

  .max-\\[1000px\\]\\:h-\\[12px\\] {
    height: 12px;
  }

  .max-\\[1000px\\]\\:min-h-\\[200px\\] {
    min-height: 200px;
  }

  .max-\\[1000px\\]\\:min-h-\\[50px\\] {
    min-height: 50px;
  }

  .max-\\[1000px\\]\\:min-h-\\[514px\\] {
    min-height: 514px;
  }

  .max-\\[1000px\\]\\:w-5 {
    width: 1.25rem;
  }

  .max-\\[1000px\\]\\:w-\\[12px\\] {
    width: 12px;
  }

  .max-\\[1000px\\]\\:w-\\[30px\\] {
    width: 30px;
  }

  .max-\\[1000px\\]\\:w-full {
    width: 100%;
  }

  .max-\\[1000px\\]\\:max-w-\\[220px\\] {
    max-width: 220px;
  }

  .max-\\[1000px\\]\\:rotate-90 {
    --tw-rotate: 90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .max-\\[1000px\\]\\:flex-col {
    flex-direction: column;
  }

  .max-\\[1000px\\]\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .max-\\[1000px\\]\\:items-center {
    align-items: center;
  }

  .max-\\[1000px\\]\\:gap-2 {
    gap: 0.5rem;
  }

  .max-\\[1000px\\]\\:gap-4 {
    gap: 1rem;
  }

  .max-\\[1000px\\]\\:p-1 {
    padding: 0.25rem;
  }

  .max-\\[1000px\\]\\:p-2 {
    padding: 0.5rem;
  }
}

@media (max-width: 920px) {

  .max-\\[920px\\]\\:mt-5 {
    margin-top: 1.25rem;
  }

  .max-\\[920px\\]\\:hidden {
    display: none;
  }
}

@media (max-width: 900px) {

  .max-\\[900px\\]\\:-left-40 {
    left: -10rem;
  }

  .max-\\[900px\\]\\:w-\\[200\\%\\] {
    width: 200%;
  }

  .max-\\[900px\\]\\:p-0 {
    padding: 0px;
  }
}

@media (max-width: 800px) {

  .max-\\[800px\\]\\:hidden {
    display: none;
  }
}

@media (max-width: 700px) {

  .max-\\[700px\\]\\:flex {
    display: flex;
  }

  .max-\\[700px\\]\\:flex-col {
    flex-direction: column;
  }
}

@media (max-width: 650px) {

  .max-\\[650px\\]\\:gap-2 {
    gap: 0.5rem;
  }

  .max-\\[650px\\]\\:p-3 {
    padding: 0.75rem;
  }

  .max-\\[650px\\]\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (max-width: 640px) {

  .max-\\[640px\\]\\:hidden {
    display: none;
  }

  .max-\\[640px\\]\\:h-\\[30px\\] {
    height: 30px;
  }

  .max-\\[640px\\]\\:w-3\\/4 {
    width: 75%;
  }

  .max-\\[640px\\]\\:w-\\[30px\\] {
    width: 30px;
  }

  .max-\\[640px\\]\\:w-full {
    width: 100%;
  }

  .max-\\[640px\\]\\:max-w-none {
    max-width: none;
  }

  .max-\\[640px\\]\\:flex-row {
    flex-direction: row;
  }

  .max-\\[640px\\]\\:items-center {
    align-items: center;
  }

  .max-\\[640px\\]\\:justify-between {
    justify-content: space-between;
  }

  .max-\\[640px\\]\\:rounded-2xl {
    border-radius: 1rem;
  }

  .max-\\[640px\\]\\:border-2 {
    border-width: 2px;
  }

  .max-\\[640px\\]\\:border-pink {
    --tw-border-opacity: 1;
    border-color: rgb(197 62 174 / var(--tw-border-opacity));
  }
}

@media (max-width: 600px) {

  .max-\\[600px\\]\\:flex-col {
    flex-direction: column;
  }

  .max-\\[600px\\]\\:items-center {
    align-items: center;
  }
}

@media (max-width: 500px) {

  .max-\\[500px\\]\\:mt-3 {
    margin-top: 0.75rem;
  }

  .max-\\[500px\\]\\:h-\\[20px\\] {
    height: 20px;
  }

  .max-\\[500px\\]\\:h-\\[250px\\] {
    height: 250px;
  }

  .max-\\[500px\\]\\:w-\\[161px\\] {
    width: 161px;
  }

  .max-\\[500px\\]\\:w-\\[40px\\] {
    width: 40px;
  }

  .max-\\[500px\\]\\:max-w-\\[20px\\] {
    max-width: 20px;
  }
}

@media (max-width: 400px) {

  .max-\\[400px\\]\\:min-h-\\[200px\\] {
    min-height: 200px;
  }
}

@media (min-width: 500px) {

  .min-\\[500px\\]\\:mt-10 {
    margin-top: 2.5rem;
  }
}

@media (min-width: 600px) {

  .min-\\[600px\\]\\:flex-row {
    flex-direction: row;
  }
}

@media (min-width: 640px) {

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:ml-4 {
    margin-left: 1rem;
  }

  .sm\\:mt-16 {
    margin-top: 4rem;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mt-3 {
    margin-top: 0.75rem;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-56 {
    height: 14rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-7 {
    height: 1.75rem;
  }

  .sm\\:h-\\[30px\\] {
    height: 30px;
  }

  .sm\\:min-h-\\[164px\\] {
    min-height: 164px;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-\\[30px\\] {
    width: 30px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:gap-\\[10px\\] {
    gap: 10px;
  }

  .sm\\:gap-\\[30px\\] {
    gap: 30px;
  }

  .sm\\:p-1 {
    padding: 0.25rem;
  }

  .sm\\:p-2 {
    padding: 0.5rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-\\[34px\\] {
    padding-left: 34px;
    padding-right: 34px;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:pr-4 {
    padding-right: 1rem;
  }

  .sm\\:pr-8 {
    padding-right: 2rem;
  }

  .sm\\:pt-32 {
    padding-top: 8rem;
  }

  .sm\\:text-center {
    text-align: center;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .sm\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .sm\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .sm\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .sm\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .min-\\[640px\\]\\:hidden {
    display: none;
  }

  .min-\\[640px\\]\\:p-2 {
    padding: 0.5rem;
  }
}

@media (min-width: 650px) {

  .min-\\[650px\\]\\:row-span-2 {
    grid-row: span 2 / span 2;
  }

  .min-\\[650px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 666px) {

  .min-\\[666px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 700px) {

  .min-\\[700px\\]\\:px-\\[40px\\] {
    padding-left: 40px;
    padding-right: 40px;
  }

  .min-\\[700px\\]\\:py-\\[40px\\] {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .min-\\[700px\\]\\:py-\\[80px\\] {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .min-\\[700px\\]\\:text-\\[18px\\] {
    font-size: 18px;
  }
}

@media (min-width: 768px) {

  @media (min-width: 640px) {

    .md\\:sm\\:flex {
      display: flex;
    }

    .md\\:sm\\:grid-cols-1 {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    .md\\:sm\\:text-sm {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
  }

  .md\\:inset-0 {
    inset: 0px;
  }

  .md\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .md\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .md\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .md\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .md\\:mb-8 {
    margin-bottom: 2rem;
  }

  .md\\:mb-\\[30px\\] {
    margin-bottom: 30px;
  }

  .md\\:mb-\\[40px\\] {
    margin-bottom: 40px;
  }

  .md\\:ml-5 {
    margin-left: 1.25rem;
  }

  .md\\:mr-6 {
    margin-right: 1.5rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-3 {
    margin-top: 0.75rem;
  }

  .md\\:mt-4 {
    margin-top: 1rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-72 {
    height: 18rem;
  }

  .md\\:h-\\[257px\\] {
    height: 257px;
  }

  .md\\:h-\\[35px\\] {
    height: 35px;
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:min-h-\\[204px\\] {
    min-height: 204px;
  }

  .md\\:w-48 {
    width: 12rem;
  }

  .md\\:w-\\[35px\\] {
    width: 35px;
  }

  .md\\:w-\\[500px\\] {
    width: 500px;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-xl {
    max-width: 36rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:gap-14 {
    gap: 3.5rem;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-7 {
    gap: 1.75rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:gap-\\[40px\\] {
    gap: 40px;
  }

  .md\\:space-x-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:rounded-none {
    border-radius: 0px;
  }

  .md\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .md\\:border-0 {
    border-width: 0px;
  }

  .md\\:bg-transparent {
    background-color: transparent;
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:p-3 {
    padding: 0.75rem;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-11 {
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:pr-6 {
    padding-right: 1.5rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .md\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .md\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .md\\:text-\\[38px\\] {
    font-size: 38px;
  }

  .md\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:font-medium {
    font-weight: 500;
  }

  .md\\:text-cyan-700 {
    --tw-text-opacity: 1;
    color: rgb(14 116 144 / var(--tw-text-opacity));
  }

  .md\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }

  .md\\:hover\\:text-cyan-700:hover {
    --tw-text-opacity: 1;
    color: rgb(14 116 144 / var(--tw-text-opacity));
  }

  .md\\:dark\\:hover\\:bg-transparent:hover:is(.dark *) {
    background-color: transparent;
  }

  .md\\:dark\\:hover\\:text-white:hover:is(.dark *) {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

@media (min-width: 800px) {

  .min-\\[800px\\]\\:max-w-\\[300px\\] {
    max-width: 300px;
  }
}

@media (min-width: 888px) {

  .min-\\[888px\\]\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 920px) {

  .min-\\[920px\\]\\:hidden {
    display: none;
  }
}

@media (min-width: 1000px) {

  .min-\\[1000px\\]\\:-right-24 {
    right: -6rem;
  }

  .min-\\[1000px\\]\\:-top-36 {
    top: -9rem;
  }

  .min-\\[1000px\\]\\:hidden {
    display: none;
  }

  .min-\\[1000px\\]\\:min-h-\\[330px\\] {
    min-height: 330px;
  }

  .min-\\[1000px\\]\\:min-h-\\[523px\\] {
    min-height: 523px;
  }

  .min-\\[1000px\\]\\:min-h-\\[576px\\] {
    min-height: 576px;
  }

  .min-\\[1000px\\]\\:min-h-\\[640px\\] {
    min-height: 640px;
  }

  .min-\\[1000px\\]\\:w-1\\/2 {
    width: 50%;
  }

  .min-\\[1000px\\]\\:min-w-\\[394px\\] {
    min-width: 394px;
  }

  .min-\\[1000px\\]\\:min-w-\\[501px\\] {
    min-width: 501px;
  }

  .min-\\[1000px\\]\\:bg-\\[length\\:100\\%_108\\%\\] {
    background-size: 100% 108%;
  }
}

@media (min-width: 1023px) {

  .min-\\[1023px\\]\\:hidden {
    display: none;
  }
}

@media (min-width: 1024px) {

  @media (min-width: 768px) {

    .lg\\:md\\:flex-nowrap {
      flex-wrap: nowrap;
    }

    .lg\\:md\\:gap-3 {
      gap: 0.75rem;
    }

    .lg\\:md\\:gap-4 {
      gap: 1rem;
    }

    .lg\\:md\\:gap-\\[22px\\] {
      gap: 22px;
    }

    .lg\\:md\\:grid {
      display: grid;
    }

    .lg\\:md\\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .lg\\:md\\:max-w-\\[300px\\] {
      max-width: 300px;
    }

    .lg\\:md\\:px-10 {
      padding-left: 2.5rem;
      padding-right: 2.5rem;
    }

    .lg\\:md\\:py-5 {
      padding-top: 1.25rem;
      padding-bottom: 1.25rem;
    }

    .lg\\:md\\:text-base {
      font-size: 1rem;
      line-height: 1.5rem;
    }

    .lg\\:md\\:w-1\\/2 {
      width: 50%;
    }
  }

  .lg\\:left-auto {
    left: auto;
  }

  .lg\\:right-0 {
    right: 0px;
  }

  .lg\\:top-\\[18px\\] {
    top: 18px;
  }

  .lg\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .lg\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .lg\\:mb-12 {
    margin-bottom: 3rem;
  }

  .lg\\:mb-20 {
    margin-bottom: 5rem;
  }

  .lg\\:mb-24 {
    margin-bottom: 6rem;
  }

  .lg\\:mb-32 {
    margin-bottom: 8rem;
  }

  .lg\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .lg\\:mb-\\[40px\\] {
    margin-bottom: 40px;
  }

  .lg\\:mb-\\[60px\\] {
    margin-bottom: 60px;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:ml-6 {
    margin-left: 1.5rem;
  }

  .lg\\:mt-10 {
    margin-top: 2.5rem;
  }

  .lg\\:mt-20 {
    margin-top: 5rem;
  }

  .lg\\:mt-4 {
    margin-top: 1rem;
  }

  .lg\\:mt-6 {
    margin-top: 1.5rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-96 {
    height: 24rem;
  }

  .lg\\:h-\\[40px\\] {
    height: 40px;
  }

  .lg\\:h-px {
    height: 1px;
  }

  .lg\\:min-h-\\[234px\\] {
    min-height: 234px;
  }

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:w-2\\/6 {
    width: 33.333333%;
  }

  .lg\\:w-\\[40px\\] {
    width: 40px;
  }

  .lg\\:w-\\[calc\\(100\\%_-_72px\\)\\] {
    width: calc(100% - 72px);
  }

  .lg\\:max-w-\\[248px\\] {
    max-width: 248px;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:gap-0 {
    gap: 0px;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-2 {
    gap: 0.5rem;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:gap-\\[56px\\] {
    gap: 56px;
  }

  .lg\\:gap-\\[60px\\] {
    gap: 60px;
  }

  .lg\\:p-0 {
    padding: 0px;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-3 {
    padding: 0.75rem;
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:p-5 {
    padding: 1.25rem;
  }

  .lg\\:p-6 {
    padding: 1.5rem;
  }

  .lg\\:p-7 {
    padding: 1.75rem;
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:px-\\[30px\\] {
    padding-left: 30px;
    padding-right: 30px;
  }

  .lg\\:px-\\[52px\\] {
    padding-left: 52px;
    padding-right: 52px;
  }

  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .lg\\:py-\\[30px\\] {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .lg\\:pr-\\[32px\\] {
    padding-right: 32px;
  }

  .lg\\:pt-36 {
    padding-top: 9rem;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-\\[21px\\] {
    font-size: 21px;
  }

  .lg\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .lg\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .lg\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .lg\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .lg\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .lg\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .lg\\:\\!leading-\\[60px\\] {
    line-height: 60px !important;
  }
}

@media (min-width: 1150px) {

  .min-\\[1150px\\]\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .min-\\[1150px\\]\\:text-\\[24px\\] {
    font-size: 24px;
  }
}

@media (min-width: 1200px) {

  .min-\\[1200px\\]\\:px-\\[80px\\] {
    padding-left: 80px;
    padding-right: 80px;
  }

  .min-\\[1200px\\]\\:py-\\[80px\\] {
    padding-top: 80px;
    padding-bottom: 80px;
  }
}

@media (min-width: 1250px) {

  .min-\\[1250px\\]\\:h-\\[400px\\] {
    height: 400px;
  }

  .min-\\[1250px\\]\\:w-\\[764px\\] {
    width: 764px;
  }
}

@media (min-width: 1300px) {

  .min-\\[1300px\\]\\:flex {
    display: flex;
  }

  .min-\\[1300px\\]\\:hidden {
    display: none;
  }

  .min-\\[1300px\\]\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 1320px) {

  .min-\\[1320px\\]\\:h-\\[525px\\] {
    height: 525px;
  }
}

@media (min-width: 1400px) {

  .min-\\[1400px\\]\\:grid {
    display: grid;
  }

  .min-\\[1400px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .min-\\[1400px\\]\\:gap-28 {
    gap: 7rem;
  }

  .min-\\[1400px\\]\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .min-\\[1400px\\]\\:text-\\[32px\\] {
    font-size: 32px;
  }
}

@media (min-width: 1440px) {

  .min-\\[1440px\\]\\:text-\\[28px\\] {
    font-size: 28px;
  }
}

.rtl\\:after\\:right-1:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  right: 0.25rem;
}

.rtl\\:after\\:right-px:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  right: 1px;
}

.rtl\\:after\\:-translate-x-full:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!hidden::-webkit-scrollbar {
  display: none !important;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!h-0::-webkit-scrollbar {
  height: 0px !important;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!w-0::-webkit-scrollbar {
  width: 0px !important;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!bg-transparent::-webkit-scrollbar {
  background-color: transparent !important;
}

.\\[\\&\\:nth-child\\(-n\\+2\\)\\]\\:w-\\[40\\%\\]:nth-child(-n+2) {
  width: 40%;
}

@media (min-width: 1575px) {

  .min-\\[1575px\\]\\:\\[\\&\\:nth-child\\(-n\\+4\\)\\]\\:w-1\\/5:nth-child(-n+4) {
    width: 20%;
  }
}

.\\[\\&\\:nth-last-child\\(-n\\+2\\)\\]\\:w-\\[40\\%\\]:nth-last-child(-n+2) {
  width: 40%;
}

.\\[\\&\\>\\*\\]\\:pointer-events-none>* {
  pointer-events: none;
}

.\\[\\&\\>\\*\\]\\:cursor-grab>* {
  cursor: grab;
}

.\\[\\&\\>\\*\\]\\:first\\:rounded-t-lg:first-child>* {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.\\[\\&\\>\\*\\]\\:last\\:rounded-b-lg:last-child>* {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.\\[\\&\\>\\*\\]\\:last\\:border-b-0:last-child>* {
  border-bottom-width: 0px;
}

.\\[\\&_\\*\\]\\:cursor-pointer * {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,yDAAc;EAAd,yCAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,wCAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,8BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,8BAAc;EAAd,yBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,mBAAc;EAAd,eAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,0BAAc;EAAd,uBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,4FAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;AAGnB;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yCAAyC,sBAAsB;;EAE7D;IACE,UAAU;EACZ;;EAEA,UAAU;EACV;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,mBAAmB;EACrB;;;;AAIF;;EAEE;;KAEG;;EAEH;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;;;;;;;;KAQG;;AAEL;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;;AAEjB;;;;AAIA;EACE,eAAe;AACjB;;AAEA;;;;;;;GAOG;;AAEH;EACE;IACE,gDAAgD;EAClD;;AAEF;AACA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,gDAAgD;;EAElD;EACA;IACE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,qCAAqC;EACvC;;EAEA;IACE;MACE,4BAA4B;IAC9B;;IAEA;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE,4BAA4B;IAC5B,sCAAsC;EACxC;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,4BAA4B;IAC9B;EACF;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAhQA;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD,mBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,qDAgQC;EAhQD;AAgQC;;AAhQD;EAAA,qDAgQC;EAhQD;AAgQC;;AAhQD;EAAA,qDAgQC;EAhQD;AAgQC;;AAhQD;EAAA,qDAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sDAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD,wBAgQC;EAhQD,wDAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sDAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,8BAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,kCAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,sDAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,8BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,2GAgQC;EAhQD,yGAgQC;EAhQD;AAgQC;;AAhQD;EAAA,2GAgQC;EAhQD,yGAgQC;EAhQD;AAgQC;;AAhQD;EAAA,2GAgQC;EAhQD,yGAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,6CAgQC;EAhQD,2DAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,4DAgQC;EAhQD,qEAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,8BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,2GAgQC;EAhQD,yGAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,qBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,eAgQC;EAhQD,eAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,uBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,yBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,iBAgQC;EAhQD,iBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,oDAgQC;EAhQD,yDAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,sBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kBAgQC;EAhQD;AAgQC;;AAhQD;EAAA,oBAgQC;EAhQD;AAgQC;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,sBAgQC;IAhQD;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,qBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,oBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,oBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,eAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;;IAAA;MAAA;IAgQC;;IAhQD;MAAA;IAgQC;;IAhQD;MAAA,mBAgQC;MAhQD;IAgQC;EAAA;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,gBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,uBAgQC;IAhQD,oDAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,8BAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,qBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,oBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,oBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,eAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,oBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,oBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,oBAgQC;IAhQD;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;;IAAA;MAAA;IAgQC;;IAhQD;MAAA;IAgQC;;IAhQD;MAAA;IAgQC;;IAhQD;MAAA;IAgQC;;IAhQD;MAAA;IAgQC;;IAhQD;MAAA;IAgQC;;IAhQD;MAAA;IAgQC;;IAhQD;MAAA,oBAgQC;MAhQD;IAgQC;;IAhQD;MAAA,oBAgQC;MAhQD;IAgQC;;IAhQD;MAAA,eAgQC;MAhQD;IAgQC;;IAhQD;MAAA;IAgQC;EAAA;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,gBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,oBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,qBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,oBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA,eAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,mBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA,kBAgQC;IAhQD;EAgQC;;EAhQD;IAAA,iBAgQC;IAhQD;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;;EAhQD;IAAA;EAgQC;AAAA;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,0BAgQC;EAhQD,uBAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;;EAAA;IAAA;EAgQC;AAAA;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA,8BAgQC;EAhQD;AAgQC;;AAhQD;EAAA,kCAgQC;EAhQD;AAgQC;;AAhQD;EAAA;AAgQC;;AAhQD;EAAA;AAgQC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n.App {\n  text-align: center;\n}\n\nmain {\n  max-width: 1576px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\niframe#webpack-dev-server-client-overlay{display:none!important}\n\n  .custom-scroll::-webkit-scrollbar {\n    width: 5px;\n  }\n  \n  /* Track */\n  .custom-scroll::-webkit-scrollbar-track {\n    background-color: #EDEDED; \n    border-radius: 20px;\n  }\n   \n  /* Handle */\n  .custom-scroll::-webkit-scrollbar-thumb {\n    background: #FE8016; \n    border-radius: 20px;\n  }\n  \n  /* Handle on hover */\n  .custom-scroll::-webkit-scrollbar-thumb:hover {\n    background: #f58930; \n  }\n\n\n\n@media (max-width:900px) {\n\n  /* main {\n    padding: 0 12px;\n  } */\n\n  section {\n    padding: 0 12px;\n    margin-bottom: 56px !important;\n  }\n\n  /* .custom-bg {\n    background-image: url('./images/background.png');\n    background-position: center;\n    background-size: 130% 100%;\n    background-size: cover !important;\n    padding-top: 30px;\n    padding-bottom: 100px;\n    background-repeat: no-repeat;\n  } */\n\n}\n\nsection {\n  width: 100%;\n  margin-bottom: 100px;\n  padding: 0 20px;\n\n}\n\n\n\n.swiper-scrollbar-drag {\n  cursor: pointer;\n}\n\n/* .custom-bg {\n  background-image: url('./images/background.png');\n  background-position: center right;\n  background-size: 85% 150%;\n  padding-top: 30px;\n  padding-bottom: 100px;\n  background-repeat: no-repeat;\n} */\n\n@media (max-width:900px) {\n  .swiper {\n    --swiper-pagination-bullet-size: 10px !important;\n  }\n\n}\n.css-1119e81-MuiPaper-root-MuiSnackbarContent-root{\n  background-color: white !important;\n  border-radius:10px;\n}\n\n.red-swiper .swiper-scrollbar-drag{\n  background-color: #D42E12 !important;\n}\n\n.MuiBox-root:focus-visible{\n  outline:none;\n  border: none;\n}\n\n.swiper-pagination{\n  display:none !important;\n}\n\n.modules-swiper .swiper-wrapper {\n  padding-bottom: 1% !important;\n}\n\n@media (max-width:900px) {\n  .swiper {\n    --swiper-pagination-bullet-size: 10px !important;\n\n  }\n  .modules-swiper {\n    padding-bottom: 40px !important;\n  }\n\n  .swiper-pagination{\n    display:block !important;\n  }\n}\n\n[type='text']:focus {\n    outline: none; \n    box-shadow: none; \n    border-color: initial;\n}\n\n.swiper-scrollbar {\n  height: 10px !important;\n}\n\n.small-scroll .swiper-scrollbar{\n  height: 5px !important;\n}\n\n.pink-scroll .swiper-scrollbar-drag{\n  background-color: #C53EAE !important;\n}\n\n.swiper-scrollbar-drag {\n  background-color: #FE8016 !important;\n}\n\n.blue-swiper .swiper-scrollbar-drag{\n  background-color: #3269A4 !important;\n}\n\n.orange-swiper .swiper-scrollbar-drag{\n  background-color: #FE8016 !important;\n}\n\n#mob_menu {\n  position: fixed;\n  right: 0;\n  top: 20px;\n  background: #1D1D1B;\n  width: 283px;\n  height: calc(100dvh - 20px);\n  border-radius: 15px 0px 0px 15px;\n  padding: 16px 16px 32px 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 40px;\n  z-index: 999;\n}\n\n#mob_menu .yellow_icon_btn {\n  max-width: 42px;\n  max-height: 42px;\n  min-width: 42px;\n  min-height: 42px;\n}\n\n#mob_menu .yellow_icon_btn img {\n  max-width: 42px;\n}\n\n@media screen and (min-width: 920px) {\n  #mob_menu {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 920px) {\n  .mob_element_open {\n    transform: translateX(0px);\n    animation: openMobElement 0.5s ease 1;\n  }\n\n  @keyframes openMobElement {\n    from {\n      transform: translateX(100vw);\n    }\n\n    to {\n      transform: translateX(0px);\n    }\n  }\n\n  .mob_element_close {\n    transform: translateX(100vw);\n    animation: closeMobElement 0.5s ease 1;\n  }\n\n  @keyframes closeMobElement {\n    from {\n      transform: translateX(0px);\n    }\n\n    to {\n      transform: translateX(100vw);\n    }\n  }\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
